import { render, staticRenderFns } from "./AssignmentInfoByShift.vue?vue&type=template&id=67253a20&"
import script from "./AssignmentInfoByShift.vue?vue&type=script&lang=js&"
export * from "./AssignmentInfoByShift.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports